export const SiftraBadge = () => {
  return (
    <a
      href="https://siftra.co/"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="siftra-badge"
      className="fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-full border border-zinc-200 bg-white/90 px-3 py-1.5 shadow-sm backdrop-blur-sm transition-opacity duration-200 hover:opacity-100 opacity-80"
    >
      <span className="text-[10px] font-medium uppercase tracking-wider text-zinc-500">
        Built &amp; Powered by
      </span>
      <img
        src="/siftra-logo.webp"
        alt="Siftra"
        className="h-4 w-auto"
      />
    </a>
  );
};

export default SiftraBadge;
